// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    VIDEO_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        videoIndexPage: action.videoIndexPage
      };
    },
    VIDEO_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        {},
        'videoIndexPage'
      );

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoIndexPage,
        ads: adModelData
      };
    },
    VIDEO_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
